import { Badge } from '../ui/badge';

/**
 * Who you are at this school, stated rather than chosen.
 *
 * This used to be a dropdown that switched the whole app between roles. Someone
 * who runs the school and teaches a class is one person with one job, so the
 * pill now simply names every role they hold — "Admin/Teacher" — and the way
 * into the teaching work is the Teaching link, not a mode.
 */
const ROLE_LABELS: Record<string, string> = {
  PRIMARY_ADMIN: 'Admin',
  ADMIN: 'Admin',
  TEACHER: 'Teacher',
  PRIMARY_FAMILY_MEMBER: 'Family',
};

/** Listed most-capable first, so the pill reads the same way for everyone. */
const ROLE_ORDER = ['PRIMARY_ADMIN', 'ADMIN', 'TEACHER', 'PRIMARY_FAMILY_MEMBER'];

export function rolePillLabel(roles: readonly string[]): string {
  const labels = ROLE_ORDER
    .filter((role) => roles.includes(role))
    .map((role) => ROLE_LABELS[role]);
  return [...new Set(labels)].join('/');
}

interface RolePillProps {
  roles: readonly string[];
}

export function RolePill({ roles }: RolePillProps) {
  const label = rolePillLabel(roles);
  if (!label) return null;
  return (
    <Badge variant="secondary" className="truncate font-medium">
      {label}
    </Badge>
  );
}

export default RolePill;
